export async function hasV2Basket(): Promise<boolean> {
  const cookie = await getBasketV2Cookie();
  return !!cookie;
}

export async function getBasketV2Cookie(): Promise<Cookie> {  
  return await window.cookieStore.get("ft-basket");
}